import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { SelectInput, TextInput } from "../../../../common/form";
import { COUNTRIES, PROVINCES } from "../../../../../utils/enums/enums";
import { Field } from "redux-form";
import { EnumWrapper } from "../../../../../utils/enums";
import { MessageBox } from "../../../../common";

const ClientAddress = ({ disabled, unauthorizedToEditPhoneNumber, countryCode, changeFieldValue, isClientBillingPeriodTypeManual, isBusinessUnitPM, isCountryCodeDisabled }) => (
  <div className="ClientSubsection">
    <h3>
      <FormattedMessage id="clients.form.civicAddress.title" />
    </h3>
    <Field
      id="address"
      name="address"
      type="text"
      component={TextInput}
      required={true}
      label={<FormattedMessage id="clients.form.civicAddress.address" />}
      disabled={disabled}
    />
    <Field
      id="city"
      name="city"
      type="text"
      component={TextInput}
      required={true}
      label={<FormattedMessage id="clients.form.civicAddress.city" />}
      disabled={disabled}
    />
    <EnumWrapper enum={COUNTRIES} format="inputs" prop="options">
      <Field
        id="countryCode"
        name="countryCode"
        props={{
          onChange: () => {
            changeFieldValue("client", "provinceCode", null);
          },
        }}
        component={SelectInput}
        disabled={disabled || isCountryCodeDisabled}
        addBlankOption={true}
        label={<FormattedMessage id="clients.form.civicAddress.country" />}
      />
    </EnumWrapper>
    {countryCode && countryCode !== " " && (
      <EnumWrapper
        enum={PROVINCES}
        query={`filters=provinces.countryCode==${countryCode}`}
        format="inputs"
        prop="options"
      >
        <Field
          id="provinceCode"
          name="provinceCode"
          component={SelectInput}
          required={true}
          disabled={disabled}
          addBlankOption={true}
          noOptionsAction={() => {
            changeFieldValue("client", "provinceCode", "noProvinces");
          }}
          label={
            <FormattedMessage id="clients.form.civicAddress.provinceCode" />
          }
        />
      </EnumWrapper>
    )}
    <Field
      id="postalCode"
      name="postalCode"
      type="text"
      maxLength="10"
      component={TextInput}
      required={true}
      label={<FormattedMessage id="clients.form.civicAddress.postalCode" />}
      disabled={disabled}
    />
    <Field
      id="phoneNumber"
      name="phoneNumber"
      type="text"
      component={TextInput}
      disabled={unauthorizedToEditPhoneNumber}
      label={<FormattedMessage id="clients.form.civicAddress.phoneNumber" />}
    />
    { isClientBillingPeriodTypeManual && isBusinessUnitPM && (
      <div>
        <MessageBox className="alert-info">
          <FormattedMessage id="clients.form.civicAddress.PMSalesTaxesInformations" />
        </MessageBox>
      </div>
    )}
  </div>
);

ClientAddress.propTypes = {
  disabled: PropTypes.bool,
  unauthorizedToEditPhoneNumber: PropTypes.bool,
  countryCode: PropTypes.string,
  changeFieldValue: PropTypes.func,
  isClientBillingPeriodTypeManual: PropTypes.bool,
  isBusinessUnitPM: PropTypes.bool,
  isCountryCodeDisabled: PropTypes.bool
};

export default ClientAddress;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/ClientAddress.js